export class FileDownloadModel {
    public Path: string;
}




// WEBPACK FOOTER //
// ./src/app/models/file-download-model.ts